// extracted by mini-css-extract-plugin
module.exports = {"bodyLight":"App_bodyLight__9Zz9_","bodyDark":"App_bodyDark__3tNpI"};